import { cva } from '@/styled-system/css';

export const toggleCardRootRecipe = cva({
  base: {
    position: 'relative',
    display: 'block',
    padding: 'default',
    borderRadius: 'obj.default',
  },
  variants: {
    disabled: {
      true: {
        'cursor': 'default',
        '& .c11n_toggle-card__root-content': {
          opacity: '0.6',
        },
      },
      false: {
        cursor: 'pointer',
      },
    },
  },
});
